import { Fragment, useContext } from "react";
import { EditableGroupContext } from "../../EditableGroup/EditableGroup";
import styles from "../styles";
import { EditableFieldProps } from "../EditableField";

const Editable = (props: { children: React.ReactNode }) => {
    const state = useContext(EditableGroupContext);
    const fieldProps = useContext(EditableFieldProps);

    if ((state.isEditing == true && fieldProps.readOnly != true) || fieldProps.alwaysVisible == true) {
        if (fieldProps.useFullWidthWhenEditing == true && state.isEditing == true) {
            return <div style={{ ...styles.paddingField, textAlign: "center" }}>{props.children}</div>
        }
        return <Fragment><div style={styles.paddingField}>{props.children}</div></Fragment>
    }
    return <Fragment />
}

export default Editable;